<script lang="ts">
    import {PUBLIC_APP_BASE} from "$env/static/public";
    import {onMount} from "svelte";
    import {page} from "$app/stores";
    import {token, user} from "$lib/stores/auth.js";
    import GlobalConfirmation from "$lib/components/GlobalConfirmation.svelte";
    import GlobalToast from "$lib/components/GlobalToast.svelte";

    const base = PUBLIC_APP_BASE;

    // user
    let localUser = null;
    user.subscribe(val => {
        localUser = val;
    })

    onMount(() => {
        // auth handling
        if ($page.url.searchParams.has('token')) {
            token.set($page.url.searchParams.get('token'))
            if (typeof localStorage !== 'undefined') {
                localStorage.setItem('token', $page.url.searchParams.get('token'))
            }

            $page.url.searchParams.delete('token')
            window.location = $page.url.href;
        }
    })
</script>
<GlobalToast/>
<GlobalConfirmation/>
<slot/>